import PropTypes from 'prop-types';
import React from 'react';
import { Dialog as MDialog } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useStyles from './styles';

const Dialog = ({
    open,
    handleClose,
    title,
    description,
    dialogActions,
    content,
    scroll,
}) => {
    const classes = useStyles();

    return (
        <MDialog
            classes={classes}
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            scroll={scroll}
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <>
                {description
                    && (
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {description}
                            </DialogContentText>
                        </DialogContent>
                    )}
                {content}
                {dialogActions
                && (
                    <DialogActions>
                        {dialogActions}
                    </DialogActions>
                )}
            </>
        </MDialog>
    );
};

export default Dialog;

Dialog.propTypes = {
    description: PropTypes.string,
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool,
    title: PropTypes.string,
    dialogActions: PropTypes.element,
    scroll: PropTypes.string,
};

Dialog.defaultProps = {
    open: false,
    title: '',
    description: '',
    dialogActions: null,
    scroll: 'paper',
};
